<template>
    <div class="modal-mask">
        <section class="modal">
            <div class="content">
                    <h1>{{$t('salesChannel.apiKey')}} {{$t('salesChannel.canalOf')}}
                        {{data.name}} ({{data['merchant-name']}})
                    </h1>
            </div>
            <hr>
            <div class="content">
                <div class="row">
                    <p class="accentuate">{{$t('created.apiKey')}}</p> 
                    <input id="api" type="text" v-model="data['api-key']" readonly/>
                    <p class="tips">{{$t('created.giveToMerchant')}}</p>
                    <div class="relative">
                        <button @click="copy()">{{$t('button.copy')}}</button>
                        <div v-if="show.textCopied" class="tooltips">{{$t('created.textIsCopied')}}</div>
                    </div>
                    <a @click="$emit('close')">
                        {{$t('button.close')}}
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data () {
            return {
                show: {
                    textCopied: false
                }
            }
        },
        methods: {
            copy() {
                document.getElementById('api').select()
                document.execCommand("copy");
                setTimeout
                this.show.textCopied = true;
                
            },
        }
    }
</script>

<style>
.tooltips {
    position: absolute;
    width: 150px;
    left: -35px;
    top: 45px;
    background-color: white;
    border: solid 1px lightgrey;
    border-radius: 5px;
    text-align: center;
}
</style>